export default __webpack_public_path__ + "locales/sr-Cyrl-RS/PDFFormDialog.json?hash=0e9dfed1f432fafc572da3f8b1b7ef41";